import React from "react";
export const BrokerRegulationCard = ({ title, text }) => (React.createElement("div", { className: "broker-regulation-card" },
    React.createElement("h5", { className: "broker-regulation-card__title", dangerouslySetInnerHTML: { __html: title } }),
    React.createElement("p", { className: "broker-regulation-card__text", dangerouslySetInnerHTML: { __html: text } })));
